import { Dropdown } from 'flowbite-react'
import React, { useState } from 'react'
import { IoSearchCircle } from 'react-icons/io5'

interface ConsultaCPFProps {
  document: string;
  setDocument: React.Dispatch<React.SetStateAction<string>>
  handleSearch: (label: string) => void
}

export const ConsultaCPF = ({ document, setDocument, handleSearch }: ConsultaCPFProps) => {
  const [label, setLabel] = useState('CPF/CNPJ')


  function maskCPFCNPJ(value: string) {
    if (value.length >= 14) {
      return value
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }

  function maskTelefone(e: string) {
    let value = e.trim();
    if (value.length === 15) {
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d{5})(\d)/, '$1-$2');
      return value
    } else if (value.length <= 14) {
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d{4})(\d)/, '$1-$2');
      return value
    }
  }



  return (
    <div>
      <h3 className='text-primary text-xl font-semibold'>Consulta</h3>
      <div className='search-box flex items-center gap-6'>
        <Dropdown label={`${label}`} inline size="md" >
          <Dropdown.Item onClick={() => setLabel("CPF/CNPJ")}>CPF/CNPJ</Dropdown.Item>
          <Dropdown.Item onClick={() => setLabel("Telefone")}>Telefone</Dropdown.Item>
          <Dropdown.Item onClick={() => setLabel("Documento")}>Documento</Dropdown.Item>
        </Dropdown>
        {/* <p className='w-22'>{label}:</p> */}
        <input type={label === 'Documento' ? 'text' : 'text'} maxLength={(label === 'CPF/CNPJ' || label === 'Telefone') ? 15 : 150} value={label === 'CPF/CNPJ' ? maskCPFCNPJ(document) : label === 'Telefone' ? maskTelefone(document) : document} className='input-container w-[15%] bg-white' onChange={(e) => setDocument(e.target.value)} />

        <button>
          <IoSearchCircle size={48} className='fill-primary' onClick={() => handleSearch(label)} />
        </button>
      </div>
    </div>
  )
}